import React, {useEffect, useState} from 'react';
import { Scrollbars } 		from 'react-custom-scrollbars-2';
import Popup                from './customComponents/Popup';
import JsonTree             from '@Components/JsonTree/JsonTree';
import ObservableService 	from '@Services/ObservableService';

const ServerErrorPopup = () => {
	const [data, setData] = useState({});

	useEffect(() => {
		ObservableService.subscribe('renderServerErrorPopup', initData);

		return () => {
			ObservableService.unsubscribe('renderServerErrorPopup', initData);
		}
	}, []);

	const close = () => {
		setData({});
	}

	const initData = (data) => {
		setData(data);
	};

	if (Object.values(data).length === 0) return '';

	const method = data?.method ?? '';

	return (
		<Popup
			zIndex = {10001}
			showTitle={true}
			title={'Oops something went wrong(Internal Server Error)'}
			className={'popup__history-task'}
			onClick={close}
		>
			<div className="popup__content label">
				<div className="flex--row_center-between padding--bottom_40">
					<div>
						<span className="color--redlight padding--right_20">{method.toUpperCase()}</span>
						<span className="color--blue_light">{data?.url ?? ''}</span>
					</div>
				</div>
				<div className="flex--row_center-between">
					<div style={{width: '50%'}}>
                        Request
						<Scrollbars autoHeight autoHeightMin={ 600 } autoHeightMax={ 600 } className="height-main__block">
							<JsonTree value={data?.data ?? {}} />
						</Scrollbars>
					</div>
					<div style={{width: '50%'}}>
                        Response
						<Scrollbars autoHeight autoHeightMin={ 600 } autoHeightMax={ 600 } className="height-main__block">
							<JsonTree value={data?.request ?? {}} />
						</Scrollbars>
					</div>
				</div>
			</div>
		</Popup>
	)
};

export default ServerErrorPopup;
